import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';
import TooltipContainer from '../../components/Onboarding/TooltipContainer/TooltipContainer';
import ModalTour from '../../components/ModalTour';
import DesktopNav from './components/DesktopNav';
import MobileNav from './components/MobileNav';
import { useNavigation } from './hooks/useNavigation';
import { useSeasonalTheme } from './hooks/useSeasonalTheme';
import { useRewardNotification } from './hooks/useRewardNotification';

/**
 * Componente AsideNav
 * Navegação lateral/inferior responsiva da aplicação
 * Em desktop: menu lateral fixo
 * Em mobile: barra de navegação inferior
 */
const AsideNav = ({ isUserAuthenticated }) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  // Redux state
  const { session } = useSelector((state) => state.session);
  const appConfigs = useSelector((state) => state.configs);

  // Verifica se o tipo de usuario
  const isPatient = session?.my_user?.typeUser?.includes("patient");
  const isTrial = session?.my_user?.typeUser?.includes("trial");
  const isFree = session?.my_user?.typeUser?.includes("free");
  
  const isPatientFree = session?.my_user?.typeUser?.includes("patient_free");
  
  // Custom hooks
  const currentTheme = useSeasonalTheme();
  const hasNewReward = useRewardNotification(appConfigs);
  const { navigationItems, activeIndex, handleNavigation } = useNavigation(
    isUserAuthenticated,
    hasNewReward,
    isPatient,
    isFree,
    isTrial,
    isPatientFree
  );

  return (
    <>
      {/* Componentes auxiliares */}
      {isUserAuthenticated && <TooltipContainer />}
      <ModalTour openModal={false} setOpenModal={() => { }} />

      {/* Renderização condicional baseada no tamanho da tela */}
      {isDesktop ? (
        <DesktopNav
          navigationItems={navigationItems}
          activeIndex={activeIndex}
          onNavigate={handleNavigation}
          currentTheme={currentTheme}
        />
      ) : (
        <MobileNav navigationItems={navigationItems} onNavigate={handleNavigation} />
      )}
    </>
  );
};

AsideNav.propTypes = {
  isUserAuthenticated: PropTypes.bool.isRequired,
};

export default AsideNav;